import { CreateApiResponse, FetchApiResponse, FilterMetadata } from "redux/types";

export enum CoLenderFinancierReduxTypes {
    FETCH_CO_LENDER_FINANCIERS = "@@auth/FETCH_CO_LENDER_FINANCIERS",
    FETCH_CO_LENDER_FINANCIERS_SUCCESS = "@@auth/FETCH_CO_LENDER_FINANCIERS_SUCCESS",
    FETCH_CO_LENDER_FINANCIERS_ERROR = "@@auth/FETCH_CO_LENDER_FINANCIERS_ERROR",

    FETCH_CO_LENDER_FINANCIER_BY_ID = "@@auth/FETCH_CO_LENDER_FINANCIER_BY_ID",
    FETCH_CO_LENDER_FINANCIER_BY_ID_SUCCESS = "@@auth/FETCH_CO_LENDER_FINANCIER_BY_ID_SUCCESS",
    FETCH_CO_LENDER_FINANCIER_BY_ID_ERROR = "@@auth/FETCH_CO_LENDER_FINANCIER_BY_ID_ERROR",

    CREATE_CO_LENDER_FINANCIER = "@@auth/CREATE_CO_LENDER_FINANCIER",
    CREATE_CO_LENDER_FINANCIER_SUCCESS = "@@auth/CREATE_CO_LENDER_FINANCIER_SUCCESS",
    CREATE_CO_LENDER_FINANCIER_ERROR = "@@auth/CREATE_CO_LENDER_FINANCIER_ERROR",

    UPDATE_CO_LENDER_FINANCIER = "@@auth/UPDATE_CO_LENDER_FINANCIER",
    UPDATE_CO_LENDER_FINANCIER_SUCCESS = "@@auth/UPDATE_CO_LENDER_FINANCIER_SUCCESS",
    UPDATE_CO_LENDER_FINANCIER_ERROR = "@@auth/UPDATE_CO_LENDER_FINANCIER_ERROR",

    RESET_CO_LENDER_FINANCIER = "@@auth/RESET_CO_LENDER_FINANCIER",

    DELETE_CO_LENDER_FINANCIER = "@@auth/DELETE_CO_LENDER_FINANCIER",
    DELETE_CO_LENDER_FINANCIER_SUCCESS = "@@auth/DELETE_CO_LENDER_FINANCIER_SUCCESS",
    DELETE_CO_LENDER_FINANCIER_ERROR = "@@auth/DELETE_CO_LENDER_FINANCIER_ERROR",

    FETCH_CO_LENDER_FINANCIER_VERSIONS = "@@auth/FETCH_CO_LENDER_FINANCIER_VERSIONS",
    FETCH_CO_LENDER_FINANCIER_VERSIONS_SUCCESS = "@@auth/FETCH_CO_LENDER_FINANCIER_VERSIONS_SUCCESS",
    FETCH_CO_LENDER_FINANCIER_VERSIONS_ERROR = "@@auth/FETCH_CO_LENDER_FINANCIER_VERSIONS_ERROR",

    FETCH_CO_LENDER_FINANCIER_LATEST_VERSIONS = "@@auth/FETCH_CO_LENDER_FINANCIER_LATEST_VERSIONS",
    FETCH_CO_LENDER_FINANCIER_LATEST_VERSIONS_SUCCESS = "@@auth/FETCH_CO_LENDER_FINANCIER_LATEST_VERSIONS_SUCCESS",
    FETCH_CO_LENDER_FINANCIER_LATEST_VERSIONS_ERROR = "@@auth/FETCH_CO_LENDER_FINANCIER_LATEST_VERSIONS_ERROR",

    FETCH_CO_LENDER_FINANCIER_VERSIONS_DETAILS = "@@auth/FETCH_CO_LENDER_FINANCIER_VERSIONS_DETAILS",
    FETCH_CO_LENDER_FINANCIER_VERSIONS_DETAILS_SUCCESS = "@@auth/FETCH_CO_LENDER_FINANCIER_VERSIONS_DETAILS_SUCCESS",
    FETCH_CO_LENDER_FINANCIER_VERSIONS_DETAILS_ERROR = "@@auth/FETCH_CO_LENDER_FINANCIER_VERSIONS_DETAILS_ERROR",

    APPROVE_CO_LENDER_FINANCIER = "@@auth/APPROVE_CO_LENDER_FINANCIER",
    APPROVE_CO_LENDER_FINANCIER_SUCCESS = "@@auth/APPROVE_CO_LENDER_FINANCIER_SUCCESS",
    APPROVE_CO_LENDER_FINANCIER_ERROR = "@@auth/APPROVE_CO_LENDER_FINANCIER_ERROR",

    REJECT_CO_LENDER_FINANCIER = "@@auth/REJECT_CO_LENDER_FINANCIER",
    REJECT_CO_LENDER_FINANCIER_SUCCESS = "@@auth/REJECT_CO_LENDER_FINANCIER_SUCCESS",
    REJECT_CO_LENDER_FINANCIER_ERROR = "@@auth/REJECT_CO_LENDER_FINANCIER_ERROR",

    BLOCK_CO_LENDER_FINANCIER = "@@auth/BLOCK_CO_LENDER_FINANCIER",
    BLOCK_CO_LENDER_FINANCIER_SUCCESS = "@@auth/BLOCK_CO_LENDER_FINANCIER_SUCCESS",
    BLOCK_CO_LENDER_FINANCIER_ERROR = "@@auth/BLOCK_CO_LENDER_FINANCIER_ERROR",

    FREEZE_CO_LENDER_FINANCIER = "@@auth/FREEZE_CO_LENDER_FINANCIER",
    FREEZE_CO_LENDER_FINANCIER_SUCCESS = "@@auth/FREEZE_CO_LENDER_FINANCIER_SUCCESS",
    FREEZE_CO_LENDER_FINANCIER_ERROR = "@@auth/FREEZE_CO_LENDER_FINANCIER_ERROR",

    UNFREEZE_CO_LENDER_FINANCIER = "@@auth/UNFREEZE_CO_LENDER_FINANCIER",
    UNFREEZE_CO_LENDER_FINANCIER_SUCCESS = "@@auth/UNFREEZE_CO_LENDER_FINANCIER_SUCCESS",
    UNFREEZE_CO_LENDER_FINANCIER_ERROR = "@@auth/UNFREEZE_CO_LENDER_FINANCIER_ERROR",
}

export type CoLenderFinancierActionDispatch = {
    type:
    | CoLenderFinancierReduxTypes.FETCH_CO_LENDER_FINANCIERS
    | CoLenderFinancierReduxTypes.CREATE_CO_LENDER_FINANCIER
    | CoLenderFinancierReduxTypes.FETCH_CO_LENDER_FINANCIER_BY_ID
    | CoLenderFinancierReduxTypes.UPDATE_CO_LENDER_FINANCIER
    | CoLenderFinancierReduxTypes.DELETE_CO_LENDER_FINANCIER
    | CoLenderFinancierReduxTypes.RESET_CO_LENDER_FINANCIER
    | CoLenderFinancierReduxTypes.FETCH_CO_LENDER_FINANCIER_VERSIONS
    | CoLenderFinancierReduxTypes.FETCH_CO_LENDER_FINANCIER_VERSIONS_DETAILS
    | CoLenderFinancierReduxTypes.FETCH_CO_LENDER_FINANCIER_LATEST_VERSIONS
    | CoLenderFinancierReduxTypes.APPROVE_CO_LENDER_FINANCIER
    | CoLenderFinancierReduxTypes.REJECT_CO_LENDER_FINANCIER
    | CoLenderFinancierReduxTypes.BLOCK_CO_LENDER_FINANCIER
    | CoLenderFinancierReduxTypes.FREEZE_CO_LENDER_FINANCIER
    | CoLenderFinancierReduxTypes.UNFREEZE_CO_LENDER_FINANCIER

    payload: any;
};

export type CoLenderFinancierReducerDispatch = {
    type:
    | CoLenderFinancierReduxTypes.FETCH_CO_LENDER_FINANCIERS
    | CoLenderFinancierReduxTypes.FETCH_CO_LENDER_FINANCIERS_SUCCESS
    | CoLenderFinancierReduxTypes.FETCH_CO_LENDER_FINANCIERS_ERROR

    | CoLenderFinancierReduxTypes.FETCH_CO_LENDER_FINANCIER_BY_ID
    | CoLenderFinancierReduxTypes.FETCH_CO_LENDER_FINANCIER_BY_ID_SUCCESS
    | CoLenderFinancierReduxTypes.FETCH_CO_LENDER_FINANCIER_BY_ID_ERROR

    | CoLenderFinancierReduxTypes.CREATE_CO_LENDER_FINANCIER
    | CoLenderFinancierReduxTypes.CREATE_CO_LENDER_FINANCIER_SUCCESS
    | CoLenderFinancierReduxTypes.CREATE_CO_LENDER_FINANCIER_ERROR

    | CoLenderFinancierReduxTypes.UPDATE_CO_LENDER_FINANCIER
    | CoLenderFinancierReduxTypes.UPDATE_CO_LENDER_FINANCIER_SUCCESS
    | CoLenderFinancierReduxTypes.UPDATE_CO_LENDER_FINANCIER_ERROR

    | CoLenderFinancierReduxTypes.RESET_CO_LENDER_FINANCIER

    | CoLenderFinancierReduxTypes.DELETE_CO_LENDER_FINANCIER
    | CoLenderFinancierReduxTypes.DELETE_CO_LENDER_FINANCIER_SUCCESS
    | CoLenderFinancierReduxTypes.DELETE_CO_LENDER_FINANCIER_ERROR

    | CoLenderFinancierReduxTypes.FETCH_CO_LENDER_FINANCIER_VERSIONS
    | CoLenderFinancierReduxTypes.FETCH_CO_LENDER_FINANCIER_VERSIONS_SUCCESS
    | CoLenderFinancierReduxTypes.FETCH_CO_LENDER_FINANCIER_VERSIONS_ERROR

    | CoLenderFinancierReduxTypes.FETCH_CO_LENDER_FINANCIER_VERSIONS_DETAILS
    | CoLenderFinancierReduxTypes.FETCH_CO_LENDER_FINANCIER_VERSIONS_DETAILS_SUCCESS
    | CoLenderFinancierReduxTypes.FETCH_CO_LENDER_FINANCIER_VERSIONS_DETAILS_ERROR

    | CoLenderFinancierReduxTypes.FETCH_CO_LENDER_FINANCIER_LATEST_VERSIONS
    | CoLenderFinancierReduxTypes.FETCH_CO_LENDER_FINANCIER_LATEST_VERSIONS_SUCCESS
    | CoLenderFinancierReduxTypes.FETCH_CO_LENDER_FINANCIER_LATEST_VERSIONS_ERROR

    | CoLenderFinancierReduxTypes.APPROVE_CO_LENDER_FINANCIER
    | CoLenderFinancierReduxTypes.APPROVE_CO_LENDER_FINANCIER_SUCCESS
    | CoLenderFinancierReduxTypes.APPROVE_CO_LENDER_FINANCIER_ERROR

    | CoLenderFinancierReduxTypes.REJECT_CO_LENDER_FINANCIER
    | CoLenderFinancierReduxTypes.REJECT_CO_LENDER_FINANCIER_SUCCESS
    | CoLenderFinancierReduxTypes.REJECT_CO_LENDER_FINANCIER_ERROR

    | CoLenderFinancierReduxTypes.BLOCK_CO_LENDER_FINANCIER
    | CoLenderFinancierReduxTypes.BLOCK_CO_LENDER_FINANCIER_SUCCESS
    | CoLenderFinancierReduxTypes.BLOCK_CO_LENDER_FINANCIER_ERROR

    | CoLenderFinancierReduxTypes.FREEZE_CO_LENDER_FINANCIER
    | CoLenderFinancierReduxTypes.FREEZE_CO_LENDER_FINANCIER_SUCCESS
    | CoLenderFinancierReduxTypes.FREEZE_CO_LENDER_FINANCIER_ERROR

    | CoLenderFinancierReduxTypes.UNFREEZE_CO_LENDER_FINANCIER
    | CoLenderFinancierReduxTypes.UNFREEZE_CO_LENDER_FINANCIER_SUCCESS
    | CoLenderFinancierReduxTypes.UNFREEZE_CO_LENDER_FINANCIER_ERROR

    payload?: {
        data?: FetchApiResponse<CoLenderFinancier>;
        error?: string;
    };
};

export type CoLenderFinancierReduxState = {
    loading?: boolean;
    data?: FetchApiResponse<CoLenderFinancier>;
    error?: string | null;
}

export type CoLenderFinancierFetchRequest = {
    payload: FilterMetadata
    type: string;
};

export type CoLenderFinancier = {
    id: string;
    externalId: string;
    status: string;
    name: string;
    taxIdentifier: string;
    taxIdentifierType: string;
    colenderSharePct?: number;
    draft: boolean;
    blocked: boolean;
    freeze: boolean;
    isFirstRecord: boolean;
    createdOn: Date;
    updatedOn: Date;
    makerRemarks: string;
};

export type CreateCoLenderFinancierRequest = {
    payload: CreateCoLenderFinancier;
    type: string;
}

export type UpdateCoLenderFinancierRequest = {
    payload: UpdateCoLenderFinancier;
    type: string;
};

export type CreateCoLenderFinancierReduxState = {
    loading: boolean;
    data?: CreateApiResponse<CoLenderFinancier>;
    error?: string | null;
};

export type CreateCoLenderFinancier = {
    name: string;
    taxIdentifier: string;
    taxIdentifierType: string;
    colenderSharePct?: number;
    makerRemarks: string;
};

export type UpdateCoLenderFinancier = {
    id: string;
    externalId: string;
    status: string;
    name: string;
    taxIdentifier: string;
    taxIdentifierType: string;
    colenderSharePct?: number;
    makerRemarks: string;
    checkerRemarks:string;
    inactiveReason:string;
    draft: boolean;
    blocked:boolean;
    freeze:boolean;
    isFirstRecord: boolean;
    createdOn: Date;
    updatedOn: Date;
};

export type CoLenderFinancierByIdRequest = {
    payload: string;
    type: string;
};